<template>
  <Consent class="consent" cancelLabelI18nKey="common.btn.back" submitLabelI18nKey="common.btn.save">
  </Consent>
</template>

<script>
import Consent from '@/views/personalNew/common/consent/index.vue'

export default {
  components: {
    Consent
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.consent {
  ::v-deep {
    .resume-applicant-mobile {
      border: none;
    }
  }
}
</style>
